import React, { Component } from 'react';

import { Button, Header, Icon, Message, Form, Input, Accordion } from 'semantic-ui-react'

import moment from 'moment-timezone'

import API_service from 'xAppLib/providers/API_service'

import obj_diff from 'xAppLib/helpers/obj_diff'
import fields_helper from 'xAppLib/UniForm/fields_helper'

import admin_users_model from 'models/admin_users_model'
import doc_model from 'models/doc_model'
import script_model from 'models/script_model'

import {ViewEditDets} from 'xAppLib/DataList'

import SelectOption from 'views/UIelems/SelectOption'
import SelectOrg from 'xAppLib/Orgs/SelectOrg'

import ProfileSyncButton from 'xAppLib/UIelems/ProfileSyncButton';

const DEFAULT_SCRIPT_DAYS_LIMIT = 14


export default class EditScript extends Component {

	constructor(props) {
		super(props);

		this.state = {
				panel: 'patient-details',
				password: '',
				message: '',
				loading: false,
				error: false
			};
	}

	//	------------------------	------------------------	------------------------

	async componentDidMount () {
	
		// this.load_recs()

		const docs = await doc_model.get_record()

		this.setState({docs_data: {'-':{name: 'Empty'}, ...docs}}) 

	}

	// 		--------------------------------		--------------------------------		---------

	static getDerivedStateFromProps(nextProps, prevState) {
		return {
				// newemail: nextProps.scr_data.email==prevState.iniemail ? prevState.newemail : nextProps.scr_data.email,
				// newname: nextProps.scr_data.displayName==prevState.ininame ? prevState.newname : nextProps.scr_data.displayName,
			}
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	async save_dets (part, d, ca) {

		const { scr_data, onChange } = this.props

		if (part=='cosm_det' && this.cosm_det_doc) {
			d.doc = this.cosm_det_doc
		}

		let data_diff = {}
		if(part=='doc') {
			d = this.det_doc
			data_diff = obj_diff({doc: scr_data.doc}, {doc: d})
		} else
			data_diff = obj_diff(scr_data[part], d)

		console.log('EditScript :: save_dets', part, scr_data.pts_uid, data_diff, Object.keys(data_diff).length)

		// med_model.update_record( med_code, d )

		// this.setState({det_mode: 'view'})
		if (!data_diff.to || !Object.keys(data_diff).length || (data_diff.to && !Object.keys(data_diff.to).length))	return


		this.setState({
						message:'',
						error:false,
						loading:true
					})

		let params = {sid:scr_data.sid, diff:{...data_diff, part}}

		const upd_res = await API_service.load_data(
									'scripts/upd_script', 
									params,
									r => ca && ca(r)
								) 

		// console.log("upd_res = %o", upd_res)

		// admin_users_model.upd_user_prof( params,  
		// 	result => {
		// 		console.log("result = %o", result)
		// 		this.setState({
		// 						newname: '',
		// 						message: result.res=='ok' && 'New profile set' || result.err_msg,
		// 						error: result.res != 'ok',
		// 						loading: false
		// 					})
		// 	} )
		let res = {[part]:d}
		if (part=='doc' && upd_res.res == 'ok') {
			const rec = upd_res.upd_rec[0]
			const ddd = rec.doc_db_data
			res = {...rec, doc_db_data__name: ddd && ddd.name || null}
		}

		onChange && onChange({...scr_data, ...res})
		ca && ca()
	}

	// 		--------------------------------		--------------------------------		---------

	save_dets_fld (part, f, d, ca) {

		const { scr_data } = this.props

		console.log('EditScript :: save_dets_fld', part, f, d, scr_data.uid, scr_data)

		// this.save_dets({[f]: d}, ca)
		// med_model.update_record( med_code, { [f]: d } )

		ca && ca()
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	handle_expiry_change(e, d) {
		const { scr_data } = this.props
		const scr_date = scr_data && (scr_data.tm && moment(scr_data.tm)) || (scr_data.add_tm && moment(scr_data.add_tm, "DD/MM/YY HH:mm:ss")) // .tm wasn't availible on some accounts (K\B)
		const new_date = d && d.value && moment(d.value)
		if (new_date && new_date.isValid() && scr_date && scr_date.isValid() && new_date > scr_date) {
			console.log('Valid date', {new_date, d, scr_date})
			this.setState({new_days_limit: new_date.diff(scr_date, 'days')})
		} else {
			console.log('Invalid date', {new_date, d, scr_date, scr_data})
			this.setState({new_days_limit: undefined})
		}
	}

	// 		--------------------------------		--------------------------------		---------

	async handle_set_expiry() {
		const { scr_data } = this.props
		if (this.state.loading_days_limit) console.log('Already loading, please wait...')
		else this.setState({loading_days_limit: true}, async _ => {
			if (typeof this.state.new_days_limit != 'undefined') await this.save_dets('meta', {patho_expiry: `${this.state.new_days_limit}` })
			this.setState({loading_days_limit: false, new_days_limit: undefined})
		})
	
	}

	// 		--------------------------------		--------------------------------		---------
	// 		--------------------------------		--------------------------------		---------

	render() {
		const { scr_data, onChange } = this.props
		const { password, newname, newemail, message, error, loading } = this.state

		scr_data.dob = moment(scr_data.dob).format("YYYY-MM-DD")

		const days_limit = scr_data && (scr_data.meta && scr_data.meta.patho_expiry || scr_data.med_db_data && scr_data.med_db_data.days_limit)
		const days_limit_num = typeof days_limit != 'undefined' && Number(days_limit) || DEFAULT_SCRIPT_DAYS_LIMIT
		const script_date = scr_data && (scr_data.tm && moment(scr_data.tm)) || (scr_data.add_tm && moment(scr_data.add_tm, "DD/MM/YY HH:mm:ss"))
		const expiry_date = !isNaN(days_limit_num) && script_date && script_date.add(days_limit_num + 1, 'days').format('YYYY-MM-DD')

		const doc_list = this.state.docs_data ? Object.keys(this.state.docs_data).map( k => ({key: k, value: k, text: this.state.docs_data[k].name,})) : null 

		const syncProfile = { scr_data, onScriptChange: onChange };
		// let user_fields_data = script_model.COMM_USR_FIELDS

		// if (scr_data.script_type=='medbuy') {
		// 	user_fields_data
		// 		.forEach ( f => {
		// 			if (f.name == 'medicare') {
		// 				f.valid_not_required = !!this.state.no_medicare
		// 			}
		// 			if (f.name == 'address') {
		// 				f.valid_not_required = false
		// 			}
		// 		} );
		// }

		// user_fields_data.push({
		// 							name: "conc_card",
		// 							type: "text",
		// 							valid_not_required: true,
		// 							pattern: "^$|^[a-zA-Z0-9]{7,12}$",
		// 							label: "If you have a valid concession card, please enter the card number",
		// 							placeholder: 'Your concession card number',
		// 						})

		const accordion_props = (index) => ({
			index,
			active: this.state.panel===index,
			onClick: (_, e) => this.setState({ panel: e.index })
		});

		return <div style={{width: '600px'}}>

			<h2>Edit Script Request details for script <br/> {scr_data.displayName} <b>{scr_data.email}</b></h2>

				{message && 
					<Message negative={error} positive={!error}>
						<p>{message}</p>
					</Message>
				}

			<Accordion styled>

			<Accordion.Title {...accordion_props("patient-details")}>
				<Header as='h3'><Icon name='dropdown' /> Patient Details</Header>
			</Accordion.Title>
			<Accordion.Content {...accordion_props("patient-details")}>

			<ViewEditDets 
					size='mini'
					itm_data = {scr_data.spd_data} 
					det_fields = {[
										...script_model.COMM_USR_FIELDS,
										/*{
											name: "conc_card",
											type: "text",
											valid_not_required: true,
											pattern: "^$|^[a-zA-Z0-9]{7,12}$",
											label: "If you have a valid concession card, please enter the card number",
											placeholder: 'Your concession card number',
										}*/
								]}

					allow_fld_edit = {false}

					// onSave_dets = { (d, ca) => console.log('EditScript :: onSave_dets', 'obj_diff', obj_diff(user, d) ) }
					// onSave_dets_fld = { (f, d, ca) => console.log('EditScript :: onSave_dets_fld', f, d, ca) }
					onSave_dets = { (d, ca) => this.save_dets('spd_data', d, ca) }
					onSave_dets_fld = { (f, d, ca) => this.save_dets_fld('spd_data', f, d, ca) }
				/>

				<ProfileSyncButton itm_data={scr_data.spd_data} syncProfile={syncProfile} containerClass="mt-4" />
			</Accordion.Content>

			<Accordion.Title {...accordion_props("assigned-doctor")}>
				<Header as='h3'><Icon name='dropdown' /> Assigned Doctor</Header>
			</Accordion.Title>
			<Accordion.Content {...accordion_props("assigned-doctor")}>
			<ViewEditDets
				size='mini'
				itm_data = {{doc: {
								get() {return scr_data.doc}, 
								doc_name: scr_data.doc_db_data__name
							}}} 
				det_fields = {script_model.COMM_DOC_FIELDS}
				cust_fields = {{
					doc_set: <SelectOption
									value={scr_data.doc}
									placeholder='Select doctor'
									onSelect={ value => this.det_doc = value }
									noConfirm={true}
									options={ doc_list }
								/>,
				}}
				
				allow_fld_edit = {false}
				onSave_dets = { (d, ca) => {this.save_dets('doc', d, ca)} }
				onSave_dets_fld = { (f, d, ca) => this.save_dets_fld('doc', f, d, ca) }
			/>
			</Accordion.Content>


			{ scr_data.script_type=='cosm' && 
				<React.Fragment>
				<Accordion.Title {...accordion_props("cosmetic-treatment-details")}>
					<Header as='h3'><Icon name='dropdown' /> Cosmetic Treatment Details</Header>
				</Accordion.Title>
					<Accordion.Content {...accordion_props("cosmetic-treatment-details")}>

					<ViewEditDets 
						size='mini'

						itm_data = {scr_data.cosm_det} 
						det_fields = { fields_helper(script_model.COMM_COSM_FIELDS, 'scredit') }

						cust_fields = {{
										doc_set: <SelectOption
														editButton
														value={scr_data.cosm_det.doc}
														placeholder='Select user doctor'
														// name={`user ${r.displayName || r.last_name} (${r.email}) - set doctor `}

														onSelect={ value=> this.cosm_det_doc = value }
														// onClear={ _=> this.del_usr_doc(r.uid) }

														noConfirm={true}

														options={ doc_list }
													/>,
									}}

						allow_fld_edit = {false}

						// onSave_dets = { (d, ca) => console.log('EditScript :: onSave_dets', 'obj_diff', obj_diff(user, d) ) }
						// onSave_dets_fld = { (f, d, ca) => console.log('EditScript :: onSave_dets_fld', f, d, ca) }
						onSave_dets = { (d, ca) => this.save_dets('cosm_det', d, ca) }
						onSave_dets_fld = { (f, d, ca) => this.save_dets_fld('cosm_det', f, d, ca) }
					/>
					</Accordion.Content>
				</React.Fragment>
			}

			{scr_data && scr_data.script_type && ['pathoreq'].includes(scr_data.script_type) && 
				<React.Fragment>
				<Accordion.Title {...accordion_props("change-expiry")}>
					<Header as='h3'><Icon name='dropdown' /> Change expiry</Header>
				</Accordion.Title>
					<Accordion.Content {...accordion_props("change-expiry")}>
					{/* <p>Expiry date: {expiry_date && expiry_date.format('YYYY-MM-DD') || 'Unknown'}</p> */}
					<Input
						type='date'
						defaultValue={expiry_date}
						onChange={(e, d) => this.handle_expiry_change(e, d)}
						//loading={this.state.loading_days_limit}
						disabled={this.state.loading_days_limit}
					/>
					<Button
						content='Set'
						onClick={_ => this.handle_set_expiry()}
						color='green'
						style={{marginLeft: '10px'}}
						loading={this.state.loading_days_limit}
						disabled={this.state.loading_days_limit || typeof this.state.new_days_limit == 'undefined'}
					/>
					{typeof this.state.new_days_limit != 'undefined' && 
						<p>New days limit: {this.state.new_days_limit}</p> ||
						<p>Days limit: {typeof days_limit != 'undefined' && days_limit || `default (${DEFAULT_SCRIPT_DAYS_LIMIT})`}</p>
					}
					</Accordion.Content>
				</React.Fragment>


			}

			<Accordion.Title {...accordion_props("org")}>
				<Header as='h3'><Icon name='dropdown' /> Org</Header>
			</Accordion.Title>
			<Accordion.Content {...accordion_props("org")}>
			<SelectOrg
				leafOnly={false}
				oid={scr_data.org_data?.oid}
				// onSelect={ org => console.log('set org', org) }
				onSelect={ async org => (await app.confirm(`Set Organisation (${org.onum}) ${org.name} ${org.type}`, `To script for ${scr_data.spd_data.first_name} ${scr_data.spd_data.email}` ) == 'yes') && this.save_dets('org_data', {oid:org.oid, name:org.name})  }
				placeholder='Set script org'
				setBtn={true}
				required={true}
			/>
			</Accordion.Content>

			</Accordion>

		</div>
	}

}
